// extracted by mini-css-extract-plugin
module.exports = {"chart":"Overview_chart__yB22z","area":"Overview_area__1URlu","headerIcon":"Overview_headerIcon__2kN5Q","fans":"Overview_fans__nPSVQ","icon":"Overview_icon__1vUeo"};